import { Component } from '@angular/core';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { WarehouseService } from 'src/app/assabil-sales/services/warehouse-service';
import { ToastrService } from 'ngx-toastr';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { WarehouseInventory } from 'src/app/assabil-sales/models/entities/warehouse-inventory';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { WarehouseInventoryLine } from 'src/app/assabil-sales/models/entities/warehouse-inventory-line';
import { SalesReportsService } from 'src/app/assabil-sales/services/sales-reports-service';
import { MatDialog } from '@angular/material/dialog';
import { LeanConfirmationComponent } from 'src/app/tools/components/lean-confirmation/lean-confirmation.component';


@Component({
  selector: 'warehouse-inventory-widget',
  templateUrl: './warehouse-inventory-widget.component.html',
  styleUrls: ['./warehouse-inventory-widget.component.scss']
})
export class WarehouseInventoryWidgetComponent extends BaseWidget  {

  warehouseInventory             : WarehouseInventory= new WarehouseInventory();

  enteredOnly                   : boolean = true;


  qcQuantity          = {'label' : 'Disponible Inv.',    writeOnly : false, readOnly : false};
  qcDamagedQuantity1  = {'label' : 'Endommagée Inv.',    writeOnly : false, readOnly : false};
  qcDamagedQuantity2  = {'label' : 'Périmée Inv.',       writeOnly : false, readOnly : false};
  

  qColumns  = [];
  
  constructor(
    public    masterDataService : MasterDataService,
    protected warehouseService  : WarehouseService,
    protected toastr            : ToastrService,
    protected baseService       : BaseService,
    protected dialog            : MatDialog,
    protected leanUtilsService  : LeanUtilsService,
    protected salesReportsService : SalesReportsService) {
    super(toastr, leanUtilsService);
  }

 //--------------------------------------------------------------------------------------------------------
  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.qColumns  = [this.qcQuantity, this.qcDamagedQuantity1, this.qcDamagedQuantity2];
  }

  
  //--------------------------------------------------------------------------------------------------------
  setEntity(warehouseInventory: WarehouseInventory) {
    warehouseInventory = this.init(warehouseInventory);

    this.warehouseInventory  = { ...warehouseInventory };
    this.warehouseInventory.warehouseInventoryLines = [];
    if (warehouseInventory.warehouseInventoryLines) {
      for (let warehouseInventoryLine of warehouseInventory.warehouseInventoryLines) {
        this.warehouseInventory.warehouseInventoryLines.push({ ...warehouseInventoryLine });
      }
    }
  }
  //--------------------------------------------------------------------------------------------------------

  //--------------------------------------------------------------------------------------------------------
  getEntity(){
    return this.warehouseInventory;
  }
  //--------------------------------------------------------------------------------------------------------



  //--------------------------------------------------------------------------------------------------------
  saveRow() : Promise<WarehouseInventory>{

    this.enteredOnly = true;

    let newWarehouseInventoryLines : WarehouseInventoryLine[] = [];

    for (let pp of this.masterDataService.salableProductPages) {
      for (let product of pp.products) {
        let found : boolean = false;
        for (let warehouseInventoryLine of this.warehouseInventory.warehouseInventoryLines) {
          if (product.productCode == warehouseInventoryLine.product.productCode) {
            found = true;
            if (
                  (! product.quantityL[0]) && (! product.quantityP[0]) && (! product.quantityU[0]) 
               && (! product.quantityL[1]) && (! product.quantityP[1]) && (! product.quantityU[1]) 
               && (! product.quantityL[2]) && (! product.quantityP[2]) && (! product.quantityU[2])
               && (! product.quantityL[3]) && (! product.quantityP[3]) && (! product.quantityU[3])
               && (! product.quantityL[4]) && (! product.quantityP[4]) && (! product.quantityU[4])
               && (! product.quantityL[5]) && (! product.quantityP[5]) && (! product.quantityU[5])
               ) {
              warehouseInventoryLine.deleted = true;
            } else {
                warehouseInventoryLine.availableQuantity  = (this.leanUtilsService.nullToZero(product.quantityL[0]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[0]) * product.loadPacking) + + this.leanUtilsService.nullToZero(product.quantityU[0]) ;
                warehouseInventoryLine.damagedQuantity1   = (this.leanUtilsService.nullToZero(product.quantityL[1]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[1]) * product.loadPacking) + + this.leanUtilsService.nullToZero(product.quantityU[1]) ;
                warehouseInventoryLine.damagedQuantity2   = (this.leanUtilsService.nullToZero(product.quantityL[2]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[2]) * product.loadPacking) + + this.leanUtilsService.nullToZero(product.quantityU[2]) ;
                warehouseInventoryLine.availableQuantityT = (this.leanUtilsService.nullToZero(product.quantityL[3]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[3]) * product.loadPacking) + + this.leanUtilsService.nullToZero(product.quantityU[3]) ;
                warehouseInventoryLine.damagedQuantity1T  = (this.leanUtilsService.nullToZero(product.quantityL[4]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[4]) * product.loadPacking) + + this.leanUtilsService.nullToZero(product.quantityU[4]) ;
                warehouseInventoryLine.damagedQuantity2T  = (this.leanUtilsService.nullToZero(product.quantityL[5]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[5]) * product.loadPacking) + + this.leanUtilsService.nullToZero(product.quantityU[5]) ;
            }
            break;
          }
        }
        if ( (! found) && 
                          ( 
                                (product.quantityL[0]) || ( product.quantityP[0]) || ( product.quantityU[0]) 
                            ||  (product.quantityL[1]) || ( product.quantityP[1]) || ( product.quantityU[1]) 
                            ||  (product.quantityL[2]) || ( product.quantityP[2]) || ( product.quantityU[2])
                            ||  (product.quantityL[3]) || ( product.quantityP[3]) || ( product.quantityU[3])
                            ||  (product.quantityL[4]) || ( product.quantityP[4]) || ( product.quantityU[4])
                            ||  (product.quantityL[5]) || ( product.quantityP[5]) || ( product.quantityU[5])
                          )) {
          let newWarehouseInventoryLine : WarehouseInventoryLine = new WarehouseInventoryLine();
            newWarehouseInventoryLine.inserted            = true;
            newWarehouseInventoryLine.product             = new Product();
            newWarehouseInventoryLine.product.productCode = product.productCode;

            newWarehouseInventoryLine.availableQuantity  = (this.leanUtilsService.nullToZero(product.quantityL[0]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[0]) * product.loadPacking) + this.leanUtilsService.nullToZero(product.quantityU[0]) ;
            newWarehouseInventoryLine.damagedQuantity1   = (this.leanUtilsService.nullToZero(product.quantityL[1]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[1]) * product.loadPacking) + this.leanUtilsService.nullToZero(product.quantityU[1]) ;
            newWarehouseInventoryLine.damagedQuantity2   = (this.leanUtilsService.nullToZero(product.quantityL[2]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[2]) * product.loadPacking) + this.leanUtilsService.nullToZero(product.quantityU[2]) ;
            newWarehouseInventoryLine.availableQuantityT = (this.leanUtilsService.nullToZero(product.quantityL[3]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[3]) * product.loadPacking) + this.leanUtilsService.nullToZero(product.quantityU[3]) ;
            newWarehouseInventoryLine.damagedQuantity1T  = (this.leanUtilsService.nullToZero(product.quantityL[4]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[4]) * product.loadPacking) + this.leanUtilsService.nullToZero(product.quantityU[4]) ;
            newWarehouseInventoryLine.damagedQuantity2T  = (this.leanUtilsService.nullToZero(product.quantityL[5]) * product.purchasePacking) + (this.leanUtilsService.nullToZero(product.quantityP[5]) * product.loadPacking) + this.leanUtilsService.nullToZero(product.quantityU[5]) ;
            
            newWarehouseInventoryLines.push(newWarehouseInventoryLine);
        }
      }
    }

    for (let warehouseInventoryLine of newWarehouseInventoryLines){
      this.warehouseInventory.warehouseInventoryLines.push(warehouseInventoryLine);
    }

    if ( (! this.warehouseInventory.warehouseInventoryLines) || (this.warehouseInventory.warehouseInventoryLines.length == 0)) {
      this.leanUtilsService.error("Aucune quantité saisie sur aucun produit");
      return null;
    }
    return this.warehouseService.warehouseInventorySave(this.warehouseInventory);
  }
  //--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
  


//--------------------------------------------------------------------------------------------------------
cancel() {

  // Create cancelation
  if (this.warehouseInventory.inserted){
    this.close();
    return;
  } 

  // Update cancelation
  this.warehouseService.warehouseInventoryGet(this.warehouseInventory.warehouseInventoryCode).then(res => {
      this.warehouseInventory = res; 
      return;
  })
}
//--------------------------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
init(warehouseInventory: WarehouseInventory) : WarehouseInventory{

  this.masterDataService.loadProductPages(6, true).then(res => {
      if (warehouseInventory.warehouseInventoryLines) {
          for (let warehouseInventoryLine of warehouseInventory.warehouseInventoryLines) {
            for (let pp of this.masterDataService.salableProductPages) {
              for (let product of pp.products) {
                if (product.productCode == warehouseInventoryLine.product.productCode) {

                  if (this.showStockInPurchasePacks() ) {

                    product.quantityL[0] = this.leanUtilsService.zeroToNull(Math.floor(warehouseInventoryLine.availableQuantity / product.purchasePacking));
                    product.quantityL[1] = this.leanUtilsService.zeroToNull(Math.floor(warehouseInventoryLine.damagedQuantity1  / product.purchasePacking));
                    product.quantityL[2] = this.leanUtilsService.zeroToNull(Math.floor(warehouseInventoryLine.damagedQuantity2  / product.purchasePacking));
                    product.quantityL[3] = this.leanUtilsService.zeroToNull(Math.floor(warehouseInventoryLine.availableQuantityT/ product.purchasePacking));
                    product.quantityL[4] = this.leanUtilsService.zeroToNull(Math.floor(warehouseInventoryLine.damagedQuantity1T / product.purchasePacking));
                    product.quantityL[5] = this.leanUtilsService.zeroToNull(Math.floor(warehouseInventoryLine.damagedQuantity2T / product.purchasePacking));
 
                    product.quantityP[0] = this.leanUtilsService.zeroToNull(Math.floor((warehouseInventoryLine.availableQuantity   % product.purchasePacking) / product.loadPacking));
                    product.quantityP[1] = this.leanUtilsService.zeroToNull(Math.floor((warehouseInventoryLine.damagedQuantity1    % product.purchasePacking) / product.loadPacking));
                    product.quantityP[2] = this.leanUtilsService.zeroToNull(Math.floor((warehouseInventoryLine.damagedQuantity2    % product.purchasePacking) / product.loadPacking));
                    product.quantityP[3] = this.leanUtilsService.zeroToNull(Math.floor((warehouseInventoryLine.availableQuantityT  % product.purchasePacking) / product.loadPacking));
                    product.quantityP[4] = this.leanUtilsService.zeroToNull(Math.floor((warehouseInventoryLine.damagedQuantity1T   % product.purchasePacking) / product.loadPacking));
                    product.quantityP[5] = this.leanUtilsService.zeroToNull(Math.floor((warehouseInventoryLine.damagedQuantity2T   % product.purchasePacking) / product.loadPacking));

                    product.quantityU[0] = this.leanUtilsService.round(warehouseInventoryLine.availableQuantity  -  (this.leanUtilsService.nullToZero(product.quantityL[0]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[0]) * product.loadPacking), product.decimalPrecision);
                    product.quantityU[1] = this.leanUtilsService.round(warehouseInventoryLine.damagedQuantity1   -  (this.leanUtilsService.nullToZero(product.quantityL[1]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[1]) * product.loadPacking), product.decimalPrecision);
                    product.quantityU[2] = this.leanUtilsService.round(warehouseInventoryLine.damagedQuantity2   -  (this.leanUtilsService.nullToZero(product.quantityL[2]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[2]) * product.loadPacking), product.decimalPrecision);
                    product.quantityU[3] = this.leanUtilsService.round(warehouseInventoryLine.availableQuantityT -  (this.leanUtilsService.nullToZero(product.quantityL[3]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[3]) * product.loadPacking), product.decimalPrecision);
                    product.quantityU[4] = this.leanUtilsService.round(warehouseInventoryLine.damagedQuantity1T  -  (this.leanUtilsService.nullToZero(product.quantityL[4]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[4]) * product.loadPacking), product.decimalPrecision);
                    product.quantityU[5] = this.leanUtilsService.round(warehouseInventoryLine.damagedQuantity2T  -  (this.leanUtilsService.nullToZero(product.quantityL[5]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[5]) * product.loadPacking), product.decimalPrecision);

                  } else {

                    product.quantityP[0] = this.leanUtilsService.zeroToNull(Math.floor(warehouseInventoryLine.availableQuantity / product.loadPacking));
                    product.quantityP[1] = this.leanUtilsService.zeroToNull(Math.floor(warehouseInventoryLine.damagedQuantity1  / product.loadPacking));
                    product.quantityP[2] = this.leanUtilsService.zeroToNull(Math.floor(warehouseInventoryLine.damagedQuantity2  / product.loadPacking));
                    product.quantityP[3] = this.leanUtilsService.zeroToNull(Math.floor(warehouseInventoryLine.availableQuantityT/ product.loadPacking));
                    product.quantityP[4] = this.leanUtilsService.zeroToNull(Math.floor(warehouseInventoryLine.damagedQuantity1T / product.loadPacking));
                    product.quantityP[5] = this.leanUtilsService.zeroToNull(Math.floor(warehouseInventoryLine.damagedQuantity2T / product.loadPacking));
  
                    product.quantityU[0] = this.leanUtilsService.round(warehouseInventoryLine.availableQuantity % product.loadPacking, product.decimalPrecision); 
                    product.quantityU[1] = this.leanUtilsService.round(warehouseInventoryLine.damagedQuantity1  % product.loadPacking, product.decimalPrecision);
                    product.quantityU[2] = this.leanUtilsService.round(warehouseInventoryLine.damagedQuantity2  % product.loadPacking, product.decimalPrecision);
                    product.quantityU[3] = this.leanUtilsService.round(warehouseInventoryLine.availableQuantityT% product.loadPacking, product.decimalPrecision);
                    product.quantityU[4] = this.leanUtilsService.round(warehouseInventoryLine.damagedQuantity1T % product.loadPacking, product.decimalPrecision);
                    product.quantityU[5] = this.leanUtilsService.round(warehouseInventoryLine.damagedQuantity2T % product.loadPacking, product.decimalPrecision);
                  }

                  pp.expand = true;
                  break;
                }
              }
            }
          }
      }
  })

  return warehouseInventory;
}
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
warehouseInventoryClose(){
  let confirmationMessage = "Confimez-vous bien la cloture de l'inventaire en cours : " + this.warehouseInventory.warehouseInventoryCode  ;

  let dialogRef = this.dialog.open(LeanConfirmationComponent, {autoFocus : false, hasBackdrop : false, data : {title : "Confirmation", confirmationMessage: confirmationMessage}});
  dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.warehouseInventoryClose2();
      }
  });

}

warehouseInventoryClose2(){
    this.warehouseService.warehouseInventoryClose(this.warehouseInventory.warehouseInventoryCode).then(res => {
      this.warehouseInventory = res; 
      this.leanUtilsService.success();
  })
}
//---------------------------------------------------------------------------------------
//---------------------------------------------------------------------------------------
print(){
  this.salesReportsService.productWarehouseInventoryPrint(this.warehouseInventory.warehouseInventoryCode)
}
printProductbatch(){
  this.salesReportsService.productBatchesPrint(this.warehouseInventory.warehouse.warehouseCode)
}

//---------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------
showStockInPurchasePacks() : boolean {
  return this.leanUtilsService.showStockInPurchasePacks;
}
//---------------------------------------------------------------------------------------

}
